import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton, CancelButton, CreateButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import axiosInstance from "../../../../Services/axiosCommon";
import { useEffect, useState } from "react";
import { TextMediumSM } from "../../../../Components/Text/MediumText";
import EditIcon from "../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../Components/Icons/Delete";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import { useToast } from "../../../../Components/Others/ToastServices";
import { GetAccess } from "../../../../Components/Utils/roles";
import { UserCog } from "lucide-react";
import { HeadingWithIcon } from "../../../../Components/Utils/Settingheading";
import { NuInput } from "../../../../Components/Utils/Input";
import { DashRole } from "./RoleData";
import { useFormik } from "formik";
import UseEditData from "../../../../Components/Hooks/useEditData";

const MainDashSettings = () => {
    const { editDashId } = useParams()
    const { Oncancel, editData, isLoading } = UseEditData();
    const [roleInfo, setRoleInfo] = useState([]);
    const [createNew, setCreateNew] = useState({
        role: "",
        permissions: []
    });

    const location = useLocation();
    const data = location.state?.data;
    const from = location.state?.from;

      const modulePermissions = {
        "DashBoard": 1,
       
    };

   const formik = useFormik({
  enableReinitialize: true,
  initialValues: createNew,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: (values, { resetForm }) => {
    const updatedValues = {
      ...values,
      role: values.role?.toLowerCase(),
      permissions: roleInfo
    };

    editData(``, updatedValues, resetForm);
  }
});


    const selectRow = (name, id) => {
        let testUser;
        if (roleInfo && roleInfo.some((Userid) => Userid === id)) {
            testUser = roleInfo.filter((roleId) => roleId !== id);
            setRoleInfo(testUser);
        } else {
            setRoleInfo([...roleInfo, id]);
        }
    };

    const toggleAllPermissions = (moduleName) => {
        const module = DashRole.find(item => item.name === moduleName);
        if (!module) return;

          const modulePermissionIds = module.roles.map(role => role.id);
        
         const allSelected = modulePermissionIds.every(id => 
            roleInfo.includes(id)
        );

        if (allSelected) {
             setRoleInfo(prev => 
                prev.filter(id => !modulePermissionIds.includes(id))
            );
        } else {
              const newPermissions = [...new Set([
                ...roleInfo,
                ...modulePermissionIds,
                modulePermissions[moduleName]
            ])];
            setRoleInfo(newPermissions);
        }
    };

    function GetPermissiom(id) {
        axiosInstance.get(``).then(res => {
            setRoleInfo(res.data?.data?.permissions || [])
        })
    }

    function GetRole(id) {
        axiosInstance.get(``).then(res => {
            let data = res.data?.data?.roleName;
            setCreateNew({ ...createNew, role: data })
        })
    }

    useEffect(() => {
        if (editDashId) {
            GetRole(editDashId)
            GetPermissiom(editDashId)
        }
    }, [editDashId])
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "View",
            },
          ]}
        />
        <div className=" flex gap-2 items-center">
          
          <BackButton />
        </div>
      </div>
       <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto px-4 py-2 rounded-md overflow-y-scroll">
                     <form onSubmit={formik.handleSubmit}>
                        
                         <div className=" w-full">
                             {DashRole.map((item, index) => {
                                   const allPermissionsSelected = item.roles.every(role => 
                                     roleInfo.includes(role.id)
                                 );
                                 
                                 return (
                                     <div key={index}>
                                         <div className="flex items-center my-2">
                                            
                                             <p className="font-semibold text-sm">{item.name}</p>
                                              <input
                                                 type="checkbox"
                                                 className="ml-2 accent-main-blue"
                                                 checked={allPermissionsSelected}
                                                 onChange={() => toggleAllPermissions(item.name)}
                                             />
                                         </div>
                                         <div className="px-6 grid gap-3 grid-cols-4">
                                             {item.roles.map((role, index) => {
                                                 return (
                                                     <div key={index} className="w-full bg-slate-100 px-2 py-4 rounded-md text-xs">
                                                         <input
                                                             type="checkbox"
                                                             className="px-3 mr-2 py-2 accent-main-blue"
                                                             checked={roleInfo.some((id) => id === role.id)}
                                                             onChange={() => selectRow(item.name, role.id)}
                                                         />
                                                         <span className="font-medium">{role.name}</span>
                                                     </div>
                                                 );
                                             })}
                                         </div>
                                     </div>
                                 );
                             })}
                         </div>
                         <div className="w-full hidden md:block mx-auto my-4 mt-8">
                             <div className="md:flex justify-end gap-4">
                                 <CancelButton handleClick={() => { Oncancel(-1) }} />
                                 <SubmitButton />
                             </div>
                         </div>
                     </form>
                 </div>
      
    </div>
  );
};

export default MainDashSettings;
